<template>
  <v-layout row justify-center align-start wrap class="mt-4 pt-2">
    <v-flex xs12 sm12 md5 lg6 xl6 class="mt-4 pt-4">
      <h2 class="mb-4 pl-4 pt-2">Experience</h2>
      <v-card-text class="py-0">
        <v-timeline align-top dense>
          <v-timeline-item color="green" small>
            <v-layout pt-3>
              <v-flex xs4>
                <div class="caption font-weight-bold green--text">2025 -</div>
                <div class="caption font-weight-bold green--text">PRESENT</div>
              </v-flex>
              <v-flex class="pl-2">
                <strong>Senior Lead AI/ML Engineer</strong>
                <div class="caption mb-2">BOOZ ALLEN HAMILTON</div>
              </v-flex>
            </v-layout>
          </v-timeline-item>

          <v-timeline-item color="green" small>
            <v-layout pt-3>
              <v-flex xs4>
                <div class="caption font-weight-bold green--text">2022 -</div>
                <div class="caption font-weight-bold green--text">2025</div>
              </v-flex>
              <v-flex class="pl-2">
                <strong>Senior Principal Data Scientist</strong>
                <div class="caption mb-2">NORTHROP GRUMMAN</div>
              </v-flex>
            </v-layout>
          </v-timeline-item>

          <v-timeline-item color="green" small>
            <v-layout pt-3>
              <v-flex xs4>
                <div class="caption font-weight-bold green--text">2020 -</div>
                <div class="caption font-weight-bold green--text">2022</div>
              </v-flex>
              <v-flex class="pl-2">
                <strong>Senior Machine Learning Engineer</strong>
                <div class="caption mb-2">RESMED</div>
              </v-flex>
            </v-layout>
          </v-timeline-item>

          <v-timeline-item color="green" small>
            <v-layout pt-3>
              <v-flex xs4>
                <div class="caption font-weight-bold green--text">2019 -</div>
                <div class="caption font-weight-bold green--text">2020</div>
              </v-flex>
              <v-flex class="pl-2">
                <strong>Data Scientist</strong>
                <div class="caption mb-2">PHILIPS</div>
              </v-flex>
            </v-layout>
          </v-timeline-item>

          <v-timeline-item color="green" small>
            <v-layout pt-3>
              <v-flex xs4>
                <div class="caption font-weight-bold green--text">2018 -</div>
                <div class="caption font-weight-bold green--text">2019</div>
              </v-flex>
              <v-flex class="pl-2">
                <strong>Engineer - Siri</strong>
                <div class="caption mb-2">APPLE</div>
              </v-flex>
            </v-layout>
          </v-timeline-item>

          <v-timeline-item color="green" small>
            <v-layout pt-3>
              <v-flex xs4>
                <div class="caption font-weight-bold green--text">2018</div>
              </v-flex>
              <v-flex class="pl-2">
                <strong>Bioinformatics Scientist</strong>
                <div class="caption mb-2">NANTOMICS</div>
              </v-flex>
            </v-layout>
          </v-timeline-item>

          <v-timeline-item color="green" small>
            <v-layout pt-3>
              <v-flex xs4>
                <div class="caption font-weight-bold green--text">2016 -</div>
                <div class="caption font-weight-bold green--text">2018</div>
              </v-flex>
              <v-flex class="pl-2">
                <strong>Bioinformatics Scientist</strong>
                <div class="caption mb-2">NANOSTRING</div>
              </v-flex>
            </v-layout>
          </v-timeline-item>

          <v-timeline-item color="green" small>
            <v-layout pt-3>
              <v-flex xs4>
                <div class="caption font-weight-bold green--text">2015 -</div>
                <div class="caption font-weight-bold green--text">2018</div>
              </v-flex>
              <v-flex class="pl-2">
                <strong>Postdoctoral Research Fellow</strong>
                <div class="caption mb-2">JOHNS HOPKINS MEDICINE</div>
              </v-flex>
            </v-layout>
          </v-timeline-item>
        </v-timeline>
      </v-card-text>
    </v-flex>

    <v-flex xs12 sm12 md4 lg6 xl6 class="mt-4 pt-2">
      <div class="text-left mb-4">
        <v-btn
          href="https://s3.us-west-1.amazonaws.com/sungheewoo.com/resume/Resume_SungheeWoo.pdf"
          target="_blank"
          color="green"
          dark
          large
          class="mr-3"
        >
          RESUME
          <v-icon right dark>fas fa-file-download</v-icon>
        </v-btn>
        <v-btn
          href="https://s3.us-west-1.amazonaws.com/sungheewoo.com/resume/comprehensive-technical-resume_Sunghee_Woo.pdf"
          target="_blank"
          color="green"
          dark
          large
        >
          RESUME (Comprehensive Technical)
          <v-icon right dark>fas fa-file-download</v-icon>
        </v-btn>
      </div>
      <h2 class="mb-4 pl-4 pt-2">Education</h2>
      <v-card-text class="py-0">
        <v-timeline align-top dense>
          <v-timeline-item color="green" small>
            <v-layout pt-3>
              <v-flex xs4>
                <div class="caption font-weight-bold green--text">2012 -</div>
                <div class="caption font-weight-bold green--text">2015</div>
              </v-flex>
              <v-flex class="pl-2">
                <strong>Phd</strong>
                <div class="caption mb-2">UCSD</div>
              </v-flex>
            </v-layout>
          </v-timeline-item>

          <v-timeline-item color="green" small>
            <v-layout pt-3>
              <v-flex xs4>
                <div class="caption font-weight-bold green--text">2009 -</div>
                <div class="caption font-weight-bold green--text">2012</div>
              </v-flex>
              <v-flex class="pl-2">
                <strong>MS</strong>
                <div class="caption mb-2">UCSD</div>
              </v-flex>
            </v-layout>
          </v-timeline-item>

          <v-timeline-item color="green" small>
            <v-layout pt-3>
              <v-flex xs4>
                <div class="caption font-weight-bold green--text">2009</div>
              </v-flex>
              <v-flex class="pl-2">
                <strong>BS</strong>
                <div class="caption mb-2">KOREA UNIVERSITY</div>
              </v-flex>
            </v-layout>
          </v-timeline-item>
        </v-timeline>
      </v-card-text>
    </v-flex>

    <v-layout row justify-center align-center wrap class="mt-4 pt-2">
      <!-- Programming Skills -->
      <v-flex xs12 sm12 md4 lg5 xl5 class="mx-2 pt-4">
        <h2>
          <span>Programming </span>
          <span class="green--text">Languages</span>
        </h2>
        <br>
        <strong>Python (15y+)</strong>
        <v-progress-linear v-model="buffer_python" :buffer-value="bufferValue" color="green" height="16"></v-progress-linear>
        <strong>C/C++ (5y+)</strong>
        <v-progress-linear v-model="buffer_cpp" :buffer-value="bufferValue" color="green" height="16"></v-progress-linear>
        <strong>Java (5y+)</strong>
        <v-progress-linear v-model="buffer_java" :buffer-value="bufferValue" color="green" height="16"></v-progress-linear>
        <strong>MATLAB (5y+)</strong>
        <v-progress-linear v-model="buffer_matlab" :buffer-value="bufferValue" color="green" height="16"></v-progress-linear>
      </v-flex>

      <!-- Cloud / Tools / Frameworks -->
      <v-flex xs12 sm12 md4 lg5 xl5 class="mx-2 pt-4">
        <h2>
          <span>Tech </span>
          <span class="green--text">Stack</span>
        </h2>
        <br>

        <strong>Cloud Computing</strong><br>
        <v-chip color="green" text-color="white" small>EC2</v-chip>
        <v-chip color="green" text-color="white" small>S3</v-chip>
        <v-chip color="green" text-color="white" small>Lambda</v-chip>
        <v-chip color="green" text-color="white" small>API Gateway</v-chip>
        <v-chip color="green" text-color="white" small>SageMaker</v-chip>
        <v-chip color="green" text-color="white" small>Glue</v-chip>
        <v-chip color="green" text-color="white" small>Athena</v-chip>
        <br><br>

        <strong>Frontend / Backend</strong><br>
        <v-chip color="green" text-color="white" small>Flutter</v-chip>
        <v-chip color="green" text-color="white" small>Vue</v-chip>
        <v-chip color="green" text-color="white" small>Flask</v-chip>
        <v-chip color="green" text-color="white" small>Django</v-chip>
        <v-chip color="green" text-color="white" small>Dash</v-chip>
        <v-chip color="green" text-color="white" small>NodeJS</v-chip>
        <br><br>

        <strong>Visualization</strong><br>
        <v-chip color="green" text-color="white" small>Matplotlib</v-chip>
        <v-chip color="green" text-color="white" small>Seaborn</v-chip>
        <v-chip color="green" text-color="white" small>Plotly</v-chip>
        <v-chip color="green" text-color="white" small>Tableau</v-chip>
        <br><br>

        <strong>Protocols / APIs</strong><br>
        <v-chip color="green" text-color="white" small>REST</v-chip>
        <v-chip color="green" text-color="white" small>CRUD</v-chip>
        <v-chip color="green" text-color="white" small>JSON</v-chip>
        <v-chip color="green" text-color="white" small>XML</v-chip>
        <v-chip color="green" text-color="white" small>HTTP</v-chip>
        <br><br>

        <strong>DB / ETL</strong><br>
        <v-chip color="green" text-color="white" small>SQL</v-chip>
        <v-chip color="green" text-color="white" small>NoSQL</v-chip>
        <v-chip color="green" text-color="white" small>Pandas</v-chip>
        <v-chip color="green" text-color="white" small>Numpy</v-chip>
        <br><br>

        <strong>Tools</strong><br>
        <v-chip color="green" text-color="white" small>Jupyter</v-chip>
        <v-chip color="green" text-color="white" small>VSCode</v-chip>
        <v-chip color="green" text-color="white" small>MS Suite</v-chip>
        <v-chip color="green" text-color="white" small>Markdown</v-chip>
        <v-chip color="green" text-color="white" small>LaTeX</v-chip>
      </v-flex>
    </v-layout>
  </v-layout>
</template>

<script>
export default {
  metaInfo: {
    title: "SungheeWoo",
    titleTemplate: "%s-Resume",
    meta: [
      { name: "viewport", content: "width=device-width, initial-scale=1" },
      {
        name: "description",
        content:
          "Vue NUXT HTML CSS JavaScript Design Adobe XD Photoshop Coding Skills Resume Work Web Developer Front-End"
      },
      { charset: "utf-8" },
      { property: "og:title", content: "Eldin' Space" },
      { property: "og:site_name", content: "Eldin' Space" },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://eldin.space" },
      {
        property: "og:image",
        content: "https://i.imgur.com/Dcz2PGx.jpg"
      },
      {
        property: "og:description",
        content:
          "Vue NUXT HTML CSS JavaScript Design Adobe XD Photoshop Coding Skills Resume Work Web Developer Front-End"
      }
    ]
  },
  data() {
    return {
      value: 0,
      buffer_flask: 0,
      buffer_flutter: 0,
      buffer_matlab: 0,
      buffer_python: 0,
      buffer_cpp: 0,
      buffer_java: 0,
      buffer_vue: 0,
      bufferValue: 100,
      interval: 0
    };
  },
  mounted() {
    this.startBuffer();
  },

  beforeDestroy() {
    clearInterval(this.interval);
  },

  methods: {
    startBuffer() {
      this.interval = setInterval(() => {
        this.buffer_flask = 100;
        this.buffer_flutter = 85;
        this.buffer_matlab = 70;
        this.buffer_python = 100;
        this.buffer_cpp = 85;
        this.buffer_java = 80;
        this.buffer_vue = 70;
      }, 800);
    }
  }
}
</script>

<style>
</style>